export const QUERY_KEY_SPECIAL_PROJECTS = 'special-projects';
